import { useMemo } from 'react'
import { useCart } from '@/features/cart/api/use-cart'

const DEFAULT_TEAWARE_WEIGHT_GRAMS = 500

/**
 * Computes total cart weight and a fingerprint string for change detection.
 */
export function useCartFingerprint() {
  const { data: cartData } = useCart()
  const items = cartData?.data?.items

  return useMemo(() => {
    if (!items || items.length === 0) {
      return { totalWeightKg: 0.5, cartFingerprint: '' }
    }

    let totalGrams = 0
    const parts: string[] = []

    for (const item of items) {
      const itemWeight = item.productType === 'tea' && item.weight
        ? item.weight * item.quantity
        : DEFAULT_TEAWARE_WEIGHT_GRAMS * item.quantity
      totalGrams += itemWeight
      parts.push(`${item.productId}:${item.weight ?? 0}:${item.quantity}`)
    }

    return {
      totalWeightKg: Math.max(totalGrams / 1000, 0.1),
      cartFingerprint: parts.sort().join(','),
    }
  }, [items])
}
